import React from 'react'
import cx from 'classnames'
import { Popover } from '@manychat/manyui'

import { Tools } from 'components/MCTextEditor/toolbar/toolbarInterfaces'
import { Decorators } from 'components/RichTextEditor/decorators/useDecorators'

import MCEditorContext from '../MCEditorContext'
import { IToolHandler } from '../types'

import TelegramRichTextToolbar from './TelegramRichTextToolbar'
import ToolsList from './ToolsList'

import cm from './Toolbar.module.css'

export interface IToolbarWrapperProps {
  className?: string
  onInsert: (value: string, selectionOffset?: number, options?: { shouldFocus: boolean }) => void
  open: boolean
  focusEditor: () => void
  isTelegramRichText?: boolean
  decorators?: Decorators
}

const Toolbar = ({
  className,
  onInsert,
  open,
  focusEditor,
  isTelegramRichText,
  decorators,
}: IToolbarWrapperProps) => {
  const { tools, withExtraToolbarSpacing } = React.useContext(MCEditorContext).toolbar

  const pointRef = React.useRef(null)
  const [isMouseOver, setIsMouseOver] = React.useState(false)
  const [selectedTool, setSelectedTool] = React.useState<string | null>(null)

  const handleMouseOver = React.useCallback(() => setIsMouseOver(true), [])

  const handleMouseOut = React.useCallback(() => setIsMouseOver(false), [])

  const handleInsert = React.useCallback<IToolHandler>(
    (value, selectionOffset, options = { closeTool: true, shouldFocus: true }) => {
      if (options.closeTool) {
        setSelectedTool(null)
      }

      onInsert(value, selectionOffset, { shouldFocus: options.shouldFocus })
    },
    [onInsert],
  )

  return (
    <>
      <div ref={pointRef} className={cm.point} />
      <Popover
        open={isMouseOver || Boolean(selectedTool) || open}
        anchor={pointRef.current}
        anchorOrigin="right bottom"
        popoverOrigin="right top"
        useLayerForClickAway={false}
        autoPosition="shift"
        className={cx(cm.popover, {
          [cm.popoverExtraSpacing]: withExtraToolbarSpacing,
          [cm.popoverHidden]: selectedTool === Tools.aiContentGenerator,
        })}
      >
        <div
          className={cx(cm.wrapper, className)}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          {isTelegramRichText && decorators ? (
            <TelegramRichTextToolbar
              decorators={decorators}
              onInsert={handleInsert}
              selectedTool={selectedTool}
              onSelectTool={setSelectedTool}
            />
          ) : (
            <ToolsList
              tools={tools}
              onInsert={handleInsert}
              selectedTool={selectedTool}
              onSelectTool={setSelectedTool}
              focusEditor={focusEditor}
            />
          )}
        </div>
      </Popover>
    </>
  )
}

export default Toolbar
